import React from 'react';
import _, { clone } from 'lodash';
import { Stack, Typography, Box, Chip, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Fab, Menu, MenuItem, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { DebounceInput } from 'react-debounce-input';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import { CssTextField } from '../../../../../../components/others/CssTextField';
import { formatDate } from '../../../../../../services/functions';
import { SmallFormDateField } from '../../../../../../components/small-fields/SmallFormDateField';
import { useApplication } from '../../../ApplicationsContext';
import { useDidMountEffect } from '../../../../../../services/hooks';
import { useSelector } from 'react-redux';

export const ZSPeriods = ({ formik, data, updateAgreementDates }) => {
  const { choices, rowData } = useApplication();
  const { seasonYear } = useSelector(state => state.app);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = event => {
    setAnchorEl(event.currentTarget);

  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const updateTimedPeriodsCallback = newRow => {
    const clonePeriods = _.cloneDeep(formik.values.zs_timed_periods);
    const idx = _.findIndex(clonePeriods, obj => obj.id == newRow.id);
    clonePeriods[idx].fixed_date = [newRow.dateFrom, newRow.dateTo];
    clonePeriods[idx].remarks = newRow.remarks;
    formik.setFieldValue('zs_timed_periods', clonePeriods);
    updateAgreementDates(clonePeriods);
  };

  const onAdd = (from, to) => {
    updateAgreementDates([
      ...formik.values.zs_timed_periods,
      { id: Date.now(), fixed_date: [formatDate(from), formatDate(to)], actual_date: [from, to], remarks: '' }
    ]);
    formik.setFieldValue('zs_timed_periods', [
      ...formik.values.zs_timed_periods,
      { id: Date.now(), fixed_date: [formatDate(from), formatDate(to)], actual_date: [from, to], remarks: '' }
    ].sort((a, b) => a.fixed_date[0] < b.fixed_date[0] ? -1 : 1));
    handleClose();
  };

  const deleteTimedPeriodCallback = id => {
    formik.setFieldValue('zs_timed_periods', _.filter(formik.values.zs_timed_periods, period => period.id != id));
    updateAgreementDates(_.filter(formik.values.zs_timed_periods, period => period.id != id));
  };

  const ZS_PERIODS_BY_YEAR = {
    2025: {
      Kwiecień: [
        ['2025-04-07', '2025-04-11', '07.04-11.04'],
        ['2025-04-14', '2025-04-16', '14.04-16.04'],
        ['2025-04-23', '2025-04-25', '23.04-25.04'],
        ['2025-04-28', '2025-04-30', '28.04-30.04']
      ],
      Maj: [
        ['2025-05-05', '2025-05-09', '05.05-09.05'],
        ['2025-05-12', '2025-05-16', '12.05-16.05'],
        ['2025-05-19', '2025-05-23', '19.05-23.05'],
        ['2025-05-23', '2025-05-25', '23.05-25.05'],
        ['2025-05-26', '2025-05-30', '26.05-30.05']
      ],
      Czerwiec: [
        ['2025-05-30', '2025-06-01', '30.05-01.06'],
        ['2025-06-02', '2025-06-06', '02.06-06.06'],
        ['2025-06-06', '2025-06-08', '06.06-08.06'],
        ['2025-06-09', '2025-06-13', '09.06-13.06'],
        ['2025-06-13', '2025-06-15', '13.06-15.06'],
        ['2025-06-16', '2025-06-18', '16.06-18.06'],
        ['2025-06-19', '2025-06-22', '19.06-22.06'],
        ['2025-06-23', '2025-06-25', '23.06-25.06']
      ],
      Wrzesień: [
        ['2025-09-03', '2025-09-05', '03.09-05.09'],
        ['2025-09-05', '2025-09-07', '05.09-07.09'],
        ['2025-09-08', '2025-09-12', '08.09-12.09'],
        ['2025-09-12', '2025-09-14', '12.09-14.09'],
        ['2025-09-15', '2025-09-19', '15.09-19.09'],
        ['2025-09-22', '2025-09-26', '22.09-26.09']
      ]
    },
    2026: {
      Kwiecień: [
        ['2026-04-08', '2026-04-10', '08.04-10.04'],
        ['2026-04-13', '2026-04-17', '13.04-17.04'],
        ['2026-04-20', '2026-04-24', '20.04-24.04'],
        ['2026-04-27', '2026-04-29', '27.04-29.04']
      ],

      Maj: [
        ['2026-05-04', '2026-05-08', '04.05-08.05'],
        ['2026-05-11', '2026-05-15', '11.05-15.05'],
        ['2026-05-18', '2026-05-22', '18.05-22.05'],
        ['2026-05-25', '2026-05-29', '25.05-29.05']
      ],

      Czerwiec: [
        ['2026-06-01', '2026-06-03', '01.06-03.06'],
        ['2026-06-04', '2026-06-07', '04.06-07.06'],
        ['2026-06-08', '2026-06-12', '08.06-12.06'],
        ['2026-06-12', '2026-06-14', '12.06-14.06'], // WEEKEND
        ['2026-06-15', '2026-06-19', '15.06-19.06'],
        ['2026-06-19', '2026-06-21', '19.06-21.06'], // WEEKEND
        ['2026-06-22', '2026-06-24', '22.06-24.06']
      ],

      Wrzesień: [
        ['2026-09-07', '2026-09-11', '07.09-11.09'],
        ['2026-09-14', '2026-09-18', '14.09-18.09'],
        ['2026-09-21', '2026-09-25', '21.09-25.09']
      ],

      Październik: [
        ['2026-09-30', '2026-10-02', '30.09-02.10'],
        ['2026-10-05', '2026-10-09', '05.10-09.10'],
        ['2026-10-12', '2026-10-16', '12.10-16.10'],
        ['2026-10-19', '2026-10-23', '19.10-23.10']
      ]
    }
  };

  const renderMenuItems = () => {
    const yearConfig = ZS_PERIODS_BY_YEAR[seasonYear];
    if (!yearConfig) {
      return null;
    }

    return Object.entries(yearConfig).flatMap(([month, periods]) => {
      if (!formik.values.zs_periods.includes(month)) {
        return [];
      }

      return periods.map(([from, to, label]) => (
        <MenuItem key={`${from}-${to}`} onClick={() => onAdd(from, to)}>
          {label}
        </MenuItem>
      ));
    });
  };


  return (
    <Stack direction="column" alignItems="left" justifyContent="center" spacing={2}>
      <Stack flex="1 1 30%">
        <SmallFormTextField
          name="zs_periods"
          select
          multiple
          placeholder=""
          value={formik.values.zs_periods}
          onChange={formik.handleChange}
          options={data.zs_periods_choices || []}
          sx={{ width: '100%' }}
          renderValue={selected => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map(value => {
                const choice = data.zs_periods_choices ? data.zs_periods_choices.find(element => value === element.value) : undefined;

                return (
                  <Chip key={value} label={choice?.label} />
                );
              })}
            </Box>
          )}
        />
      </Stack>
      <Stack flex="1 1 70%">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '40%' }} align="left">Data domyślna</TableCell>
                {/* <TableCell align="left">Data faktyczna</TableCell> */}
                <TableCell sx={{ width: '50%' }} align="left">Uwagi</TableCell>
                <TableCell align="left">
                  <Stack justifyContent="center" direction="row" alignItems="center">
                    <Tooltip title="Wybierz datę z listy...">
                      <Fab
                        size="small"
                        color="primary"
                        aria-label="add"
                        onClick={e => handleOpen(e)}
                      >
                        <AddIcon style={{ fontSize: '20px' }} />
                      </Fab>
                    </Tooltip>
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                      {renderMenuItems()}

                      <MenuItem onClick={() => onAdd(null, null)}>
                        Wpisz datę ręcznie
                      </MenuItem>
                    </Menu>
                  </Stack>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formik.values.zs_timed_periods.map((row, key) => (
                <Row key={key} row={row} updateTimedPeriodsCallback={updateTimedPeriodsCallback} deleteTimedPeriodCallback={deleteTimedPeriodCallback} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="center" sx={{ my: 2, width: '100%' }}>
        <Stack direction="row" alignItems="center" justifyContent="center" sx={{ my: 2, width: '50%' }}>
          <Typography variant="subtitle2" sx={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Miejsce wykonania przedmiotu umowy</Typography>
          <SmallFormTextField
            name="resort"
            select
            placeholder="Ośrodek"
            value={formik.values.resort_for_agreement}
            onChange={e => formik.setFieldValue('resort_for_agreement', e.target.value)}
            options={data.resort_for_agreement_choices}
            sx={{ width: '100%' }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

function Row({ row, updateTimedPeriodsCallback, deleteTimedPeriodCallback }) {
  const [fixedDateFrom, setFixedDateFrom] = React.useState(row.fixed_date[0]);
  const [fixedDateTo, setFixedDateTo] = React.useState(row.fixed_date[1]);
  const [remarks, setRemarks] = React.useState(row.remarks);
  const [updateSignal, setUpdateSignal] = React.useState(false);

  React.useEffect(() => {
    setFixedDateFrom(row.fixed_date[0]);
    setFixedDateTo(row.fixed_date[1]);
    setRemarks(row.remarks);
  }, [row]);

  const constructProduct = () => (
    { id: row.id, dateFrom: fixedDateFrom, dateTo: fixedDateTo, remarks }
  );

  useDidMountEffect(() => {
    updateTimedPeriodsCallback(constructProduct());
  }, [updateSignal]);

  const handleDelete = () => {
    deleteTimedPeriodCallback(row.id);
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="left">
          <Stack direction="row" alignItems="center" justifyContent="center">
            <SmallFormDateField
              type="text"
              placeholder="data od"
              value={fixedDateFrom}
              onChange={val => {
                setFixedDateFrom(formatDate(val));
                setUpdateSignal(!updateSignal);

              }}
            />
          &nbsp;-&nbsp;
            <SmallFormDateField
              type="text"
              placeholder="fixedDateTo"
              value={fixedDateTo}
              onChange={val => {
                setFixedDateTo(formatDate(val));
                setUpdateSignal(!updateSignal);
              }}
            />
          </Stack>
        </TableCell>
        <TableCell align="left">
          <DebounceInput
            sx= {{ width: '90%' }}
            name="remarks"
            debounceTimeout={600}
            value={remarks}
            element={CssTextField}
            onChange={e => {
              setRemarks(e.target.value);
              setUpdateSignal(!updateSignal);
            }}
            variant="outlined"
          />
        </TableCell>
        <TableCell>
          <Tooltip title="Usuń">
            <DeleteIcon style={{ fontSize: '30px', cursor: 'pointer', color: 'red', flex: '0 0 10%' }} onClick={e => handleDelete(e)} />
          </Tooltip>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
